import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5def44bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "hero",
  "aria-labelledby": "hero-title"
}
const _hoisted_2 = { class: "hero__content" }
const _hoisted_3 = { class: "hero__role" }
const _hoisted_4 = { id: "hero-title" }
const _hoisted_5 = { class: "hero__intro" }
const _hoisted_6 = { class: "hero__actions" }
const _hoisted_7 = ["href"]

import ArrowRightIcon from "@/components/icons/ArrowRightIcon.vue";
import { profile } from "@/data/profile";

export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileHero',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(profile).roleLine), 1),
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(profile).headline), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(profile).intro), 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("a", {
          class: "button-link button-link--yellow",
          href: _unref(profile).primaryAction.href
        }, [
          _createTextVNode(_toDisplayString(_unref(profile).primaryAction.label) + " ", 1),
          _createVNode(ArrowRightIcon, { class: "button-link__svg-icon" })
        ], 8, _hoisted_7)
      ])
    ])
  ]))
}
}

})